module.exports = __webpack_public_path__ + "img/stick_activites_chien_traineau.139890f2.svg";